export default __webpack_public_path__ + "static/media/strapi-connection.58c30d77.webp";